import { render, staticRenderFns } from "./condicoesgeraisDetalhar.vue?vue&type=template&id=71636d03&"
import script from "./condicoesgeraisDetalhar.vue?vue&type=script&lang=js&"
export * from "./condicoesgeraisDetalhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports